import {useNavigate, useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {
    CheckIcon,
    ThickAddIcon,
    ThinAbsentIcon,
    ThinAddIcon,
    ThinCallIcon,
    ThinCardIcon,
    ThinCaretDownIcon,
    ThinCreditScoreIcon,
    ThinEditIcon,
    ThinInfoIcon,
    ThinPersonIcon,
    ThinPrintIcon,
    ThinStoreIcon,
    ThinTaskIcon,
    ThinTimeIcon,
    ThinTrashIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {AddEditStudentModal} from "./add-edit-student";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {Apis} from "../../../components/api/url";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AddBalanceModal} from "./add-balance";
import {StudentMaxPayPerDayEditModal} from "../settings/max-pay-modal";
import '../../../static/css/pages/settings/store-max.css';
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {GradeToString} from "./list";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AddEditTuitionPaymentModal} from "./add-edit-tuition-payment";
import {AddEditTuitionReminderModal} from "./add-edit-tuition-reminder";
import {SignTuitionModal} from "./sign-tuition";
import {AdminTuitionPaymentInfoModal} from "./payment-info-modal";
import {AdminPayTuitionModal} from "./pay-tuition-modal";
import {AdminsAssignCardToStudentModal} from "./assign-card";
import {AdminsEditWhoGetsSMSModal} from "./who-get-sms-modal";
import {AdminsEditWhoGetsConsentsSMSModal} from "./who-get-consent-modal";

export interface tuitionInterface {
    id: number,
    price: number,
    paidAt: string,
    payMethod: "online" | "cash" | "old",
}

export interface entranceLogSingleInterface {
    id: number,
    isEntrance: 0 | 1,
    createdAt: string,
    isAuto: 0 | 1,
}

interface pointTransactionSingleInterface {
    id: number,
    isSale: 0 | 1,
    price: number,
    source: 'device' | 'operator' | 'online' | 'station',
    method: 'online' | 'cash' | 'credit',
    createdAt: string,
}

export interface reminderInterface {
    id: number,
    price: number,
    date: string,
    isReminded: 0 | 1,
}

export const AdminStudentDetailsScreen = () => {
    const {studentId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        firstname: '',
        lastname: '',
        national: '',
        grade: 1,
        fatherName: '',
        birthSerial: '',
        homeTell: '',
        fatherJob: '',
        motherName: '',
        motherTell: '',
        motherCert: '',
        motherJob: '',
        zipcode: '',
        address: '',
        balance: 0,
        maxBuyPerDay: 0,
        isInside: false,
        tuition: [] as tuitionInterface[], // paid
        tuitionMode: "dept" as "dept" | "upfront" | "free",
        smsIfEnter: false,
        smsIfExit: false,
        smsIfAbsent: false,
        tuitionTotalPrice: 0,
        isTuitionSet: false,
        defaultTuitionPrice: 0,
        tuitionPercentPaid: 0,
        tuitionPaidSoFar: 0,
        birthDate: '2000-01-01',
        fatherCert: '',
        fatherTell: '',
        classId: 0,
        className: '',
        defaultExtraProgramCost: 0,
        extraProgramCost: 0,
        offAmount: 0,
        cardCode: '',
        whoGetsSMS: 'father',
        consentSMS: 'default',
    });
    const [can, setCan] = useState({
        addEdit: false,
        tuition: false,
        reminders: false,
        attend: false,
        point: false,
    });
    const navigate = useNavigate();
    const [remindersList, setRemindersList] = useState([] as reminderInterface[]);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/students/details',
            {id: studentId as string},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstname: string,
                lastname: string,
                national: string,
                grade: number,
                fatherName: string,
                birthSerial: string,
                homeTell: string,
                fatherJob: string,
                motherName: string,
                motherTell: string,
                motherCert: string,
                motherJob: string,
                zipcode: string,
                address: string,
                balance: number,
                maxBuyPerDay: number,
                isInside: 0 | 1,
                tuition: tuitionInterface[] | null,
                tuitionMode: "dept" | "upfront" | "free",
                smsIfEnter: boolean,
                smsIfExit: boolean,
                smsIfAbsent: boolean,
                tuitionPrice: number,
                defaultTuition: number,
                reminders: reminderInterface[] | null,
                birthDate: string,
                fatherTell: string,
                fatherCert: string,
                classId: number,
                className: string,
                defaultExtraProgramCost: number,
                extraProgramCost: number,
                offAmount: number,
                cardCode: string,
                whoGetsSMS: string,
                consentSMS: string,
                canAdd: boolean,
                canTuition: boolean,
                canReminder: boolean,
                canAttend: boolean,
                canPoint: boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'not-found') {
                        ShowSnackbar('دانش‌آموز مورد نظر یافت نشد.', 'باشه', 5000);
                        navigate('/admins/students',{replace:true});
                    }
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                let paidSoFar = 0;
                let paidPercent = 0;
                if (d.tuition !== null && d.tuitionPrice > 0) {
                    d.tuition.forEach(t => {
                        paidSoFar += t.price;
                    });
                    paidPercent = (paidSoFar * 100) / d.tuitionPrice; // >0 makes sure DIVISION_BY_ZERO not happen
                }
                setRemindersList(d.reminders === null ? [] : d.reminders);
                document.title = `${d.firstname + " " + d.lastname} | دانش‌آموزان | نهال`;
                setData({
                    loaded: true,
                    firstname: d.firstname,
                    lastname: d.lastname,
                    national: d.national,
                    grade: d.grade,
                    fatherName: d.fatherName,
                    birthSerial: d.birthSerial,
                    homeTell: d.homeTell,
                    fatherJob: d.fatherJob,
                    motherName: d.motherName,
                    motherTell: d.motherTell,
                    motherCert: d.motherCert,
                    motherJob: d.motherJob,
                    zipcode: d.zipcode,
                    address: d.address,
                    balance: d.balance,
                    maxBuyPerDay: d.maxBuyPerDay,
                    isInside: d.isInside === 1,
                    tuition: d.tuition === null ? [] : d.tuition,
                    tuitionMode: d.tuitionMode,
                    smsIfEnter: d.smsIfEnter,
                    smsIfExit: d.smsIfExit,
                    smsIfAbsent: d.smsIfAbsent,
                    isTuitionSet: d.tuitionPrice !== -1,
                    tuitionTotalPrice: d.tuitionPrice < 0 ? 0 : d.tuitionPrice,
                    defaultTuitionPrice: d.defaultTuition,
                    tuitionPaidSoFar: paidSoFar,
                    tuitionPercentPaid: paidPercent,
                    birthDate: d.birthDate,
                    fatherCert: d.fatherCert,
                    fatherTell: d.fatherTell,
                    classId: d.classId,
                    className: d.className,
                    defaultExtraProgramCost: d.defaultExtraProgramCost,
                    extraProgramCost: d.extraProgramCost,
                    offAmount: d.offAmount,
                    cardCode: d.cardCode,
                    whoGetsSMS: d.whoGetsSMS,
                    consentSMS: d.consentSMS,
                });
                setCan({
                    addEdit: d.canAdd,
                    attend: d.canAttend,
                    point: d.canPoint,
                    tuition: d.canTuition,
                    reminders: d.canReminder,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [editModal, setEditModal] = useState(false);
    //const [tuitionUnknown, setTuitionUnknown] = useState(true);
    const [increaseBalanceModal, setIncreaseBalanceModal] = useState(false);
    const [editMaxModal, setEditMaxModal] = useState(false);
    const ChangeSMSConditions = (ifAbsent: number = -1, ifEnter: number = -1, ifExit: number = -1) => {
        let sms = {...data};
        if (ifAbsent > -1)
            sms.smsIfAbsent = ifAbsent === 1;
        if (ifEnter > -1)
            sms.smsIfEnter = ifEnter === 1;
        if (ifExit > -1)
            sms.smsIfExit = ifExit === 1;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/sms',
            {
                id: studentId as string,
                a1: sms.smsIfAbsent ? '1' : '0',
                a2: sms.smsIfEnter ? '1' : '0',
                a3: sms.smsIfExit ? '1' : '0',
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar('تنظیمات اطلاع‌رسانی این دانش‌آموز تغییر یافت.', 'باشه', 5000);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [attendList, setAttendList] = useState<entranceLogSingleInterface[]>([]);
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [timeForStore, setTimeForStore] = useState<DayRange>({from: null, to: null});
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const [storeFilters, setStoreFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const fetchList = () => {
        setFilters({shown: ''});
        const t = {...time};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        ShowProgressLoading();
        //window.scrollTo({top: 0, behavior: 'smooth'});
        PostJSON(
            Apis.server + "/core/admins/students/attend/history",
            {
                f: fromString,
                t: toString,
                id: studentId as string,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: entranceLogSingleInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setAttendList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [storeList, setStoreList] = useState([] as pointTransactionSingleInterface[]);
    const fetchStoreList = () => {
        setStoreFilters({shown: ''});
        const t = {...timeForStore};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTimeForStore({
                from: from,
                to: to,
            });
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/students/point/transactions",
            {
                f: fromString,
                t: toString,
                id: studentId as string,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: pointTransactionSingleInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setStoreList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [tab, setTab] = useState('info' as 'info' | 'tuition' | 'store' | 'attend' | 'center');
    useEffect(() => {
        const t = tab;
        if (t === 'store') {
            fetchStoreList();
        } else if (t === 'attend') {
            fetchList();
        }
    }, [tab]);
    const [removePayment, setRemovePayment] = useState({
        show: false,
        id: 0,
    });
    const doRemovePayment = () => {
        const paymentId = removePayment.id;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/payments/remove',
            {id: paymentId.toString()},
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                fetchData();
                ShowSnackbar('پرداخت موردنظر حذف شد.', 'باشه', 5000);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [removeReminder, setRemoveReminder] = useState({
        show: false,
        id: 0,
    });
    const doRemoveReminder = () => {
        const reminderId = removeReminder.id;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/reminders/remove',
            {id: reminderId.toString()},
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                fetchData();
                ShowSnackbar('یادآوری موردنظر حذف شد.', 'باشه', 5000);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [addEditPayment, setAddEditPayment] = useState({
        show: false,
        id: 0,
        edit: false,
        price: 0,
        paidDate: '2000-01-01 00:00:00',
        payMethod: 'online' as "online" | "cash" | "old",
    });
    const [addEditReminder, setAddEditReminder] = useState({
        show: false,
        id: 0,
        edit: false,
        date: '2000-01-01',
        price: 0,
        isReminded: false,
    });
    const [signModal, setSignModal] = useState(false);
    const [paymentInfoModal, setPaymentInfoModal] = useState({
        show: false,
        id: 0,
    });
    const [payModal, setPayModal] = useState({
        show: false,
        price: 0,
    });
    const [removeCard, setRemoveCard] = useState(false);
    const [assignCard, setAssignCard] = useState(false);
    const [whoGetsSMS, setWhoGetsSMS] = useState(false);
    const [whoGetsConsents, setWhoGetsConsents] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'دانش‌آموزان', url: '/admins/students'},
                {
                    title: data.loaded ? `${data.firstname} ${data.lastname}` : '...',
                    url: '/admins/students/view/' + studentId
                },
            ]}/>
            {
                data.loaded ?
                    <div className="container">
                        <div className="open-tabbar" style={{marginTop: 20}}>
                            <div className="open-tabbar-inner">
                                <button onClick={() => {
                                    setTab('info');
                                    window.scrollTo({top: 0, behavior: 'smooth'});
                                }} className={tab === 'info' ? 'active' : ''}>
                                    <ThinPersonIcon/>
                                    مشخصات
                                </button>
                                {
                                    can.tuition ?
                                        <button onClick={() => {
                                            setTab('tuition');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'tuition' ? 'active' : ''}>
                                            <ThinCreditScoreIcon/>
                                            شهریه
                                        </button> : null
                                }
                                {
                                    can.point ?
                                        <button onClick={() => {
                                            setTab('store');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'store' ? 'active' : ''}>
                                            <ThinStoreIcon/>
                                            بوفه
                                        </button> : null
                                }
                                {
                                    can.attend ?
                                        <button onClick={() => {
                                            setTab('attend');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'attend' ? 'active' : ''}>
                                            <ThinAbsentIcon/>
                                            حضورغیاب
                                        </button> : null
                                }
                            </div>
                        </div>
                        {/*{*/}
                        {/*    tuitionUnknown ?*/}
                        {/*        <div className="page-top-warning">*/}
                        {/*            <span>دانش‌آموز دارای یک قسط پرداخت نشده می‌باشد که از زمان آن گذشته است.</span>*/}
                        {/*            <button onClick={() => setTuitionUnknown(false)}><ThinCloseIcon/></button>*/}
                        {/*        </div> : null*/}
                        {/*}*/}
                        {
                            tab === 'info' ?
                                <>
                                    <div className="row" data-aos="fade-up" data-aos-duration="1000">
                                        <div className="col-lg-4">
                                            <div className="student-profile">
                                                <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                                <b>{data.firstname + " " + data.lastname}</b>
                                                <span>{GradeToString(data.grade)}</span>
                                                <em data-color={data.isInside ? 'blue' : 'red'}>
                                                    {data.isInside ? 'داخل محوطه' : 'عدم حضور'}
                                                </em>
                                                <strong>{data.classId > 0 ? `کلاس ${data.className}` : 'کلاس نامشخص'}</strong>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="screen-card">
                                                <div className="screen-card-header">
                                                    <b>مشخصات دانش‌آموز</b>
                                                    {
                                                        can.addEdit ?
                                                            <button onClick={() => setEditModal(true)}>
                                                                <ThinEditIcon/>
                                                                <span>ویرایش</span>
                                                            </button> : null
                                                    }
                                                </div>
                                                <div className="student-info">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <span>نام و نام‌خانوادگی:</span>
                                                            <b>{data.firstname + " " + data.lastname}</b>
                                                            <span>کدملی:</span>
                                                            <b>{StringDigitsConvertToPersian(data.national)}</b>
                                                            <span>پایه تحصیلی:</span>
                                                            <b>{GradeToString(data.grade)}</b>
                                                            <span>سریال شناسنامه:</span>
                                                            <b>{data.birthDate === "" ? "نامشخص" : StringDigitsConvertToPersian(data.birthSerial)}</b>
                                                            <span>تلفن منزل:</span>
                                                            <b data-link="yes">
                                                                {StringDigitsConvertToPersian(data.homeTell)}
                                                                <a href={`tel:${data.homeTell}`}
                                                                   className="open-tooltip">
                                                                    <ThinCallIcon/>
                                                                    <i>تماس تلفنی</i>
                                                                </a>
                                                            </b>
                                                            <span>تاریخ تولد:</span>
                                                            <b>{StringDigitsConvertToPersian(GregorianToPersian(data.birthDate).replaceAll('-', '/'))}</b>
                                                            <span>نام پدر:</span>
                                                            <b>{data.fatherName}</b>
                                                            <span>مدرک تحصیلی پدر:</span>
                                                            <b>{data.fatherCert}</b>
                                                            <span>دریافت‌کننده پیامک:</span>
                                                            <b data-link="yes">
                                                                {data.whoGetsSMS === 'father' ? 'پدر' : (data.whoGetsSMS === 'mother' ? 'مادر' : 'نامشخص')}
                                                                <button className="open-tooltip"
                                                                        onClick={() => setWhoGetsSMS(true)}>
                                                                    <ThinEditIcon/>
                                                                    <i>ویرایش</i>
                                                                </button>
                                                            </b>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <span>تلفن پدر:</span>
                                                            <b>
                                                                {StringDigitsConvertToPersian(data.fatherTell)}
                                                                <a href={`tel:${data.fatherTell}`}
                                                                   className="open-tooltip">
                                                                    <ThinCallIcon/>
                                                                    <i>تماس تلفنی</i>
                                                                </a>
                                                            </b>
                                                            <span>شغل پدر:</span>
                                                            <b>{data.fatherJob}</b>
                                                            <span>نام مادر:</span>
                                                            <b>{data.motherName}</b>
                                                            <span>تلفن مادر:</span>
                                                            <b>
                                                                {StringDigitsConvertToPersian(data.motherTell)}
                                                                <a href={`tel:${data.motherTell}`}
                                                                   className="open-tooltip">
                                                                    <ThinCallIcon/>
                                                                    <i>تماس تلفنی</i>
                                                                </a>
                                                            </b>
                                                            <span>مدرک مادر:</span>
                                                            <b>{data.motherCert}</b>
                                                            <span>شغل مادر:</span>
                                                            <b>{data.motherJob}</b>
                                                            <span>کدپستی:</span>
                                                            <b>{StringDigitsConvertToPersian(data.zipcode)}</b>
                                                            <span>نشانی منزل:</span>
                                                            <b>{data.address}</b>
                                                            <span>پیامک رضایت‌نامه توسط:</span>
                                                            <b data-link="yes">
                                                                {data.consentSMS === 'default' ? 'مطابق دریافت‌کننده پیامک' : (data.consentSMS === 'father' ? 'پدر' : 'مادر')}
                                                                <button className="open-tooltip"
                                                                        onClick={() => setWhoGetsConsents(true)}>
                                                                    <ThinEditIcon/>
                                                                    <i>ویرایش</i>
                                                                </button>
                                                            </b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="screen-card">
                                                <div className="screen-card-header">
                                                    <b>کارت های دانش‌آموز</b>
                                                    <button onClick={() => setAssignCard(true)}>
                                                        <ThinAddIcon/>
                                                        <span>ثبت کارت</span>
                                                    </button>
                                                </div>
                                                {
                                                    data.cardCode === '' ?
                                                        <div className="staff--not-found">
                                                            <b>کارتی ثبت نشده</b>
                                                            <p>برای این مشتری تاکنون کارتی ثبت نشده است.</p>
                                                        </div> :
                                                        <div className="finger-item">
                                                            <div>
                                                                <em><ThinCardIcon/></em>
                                                                <div>
                                                                    <b>{data.cardCode}</b>
                                                                    <span>کارت هوشمند غیرتماسی.</span>
                                                                </div>
                                                            </div>
                                                            <button className="open-tooltip"
                                                                    onClick={() => setRemoveCard(true)}>
                                                                <ThinTrashIcon/>
                                                                <i>عدم اختصاص</i>
                                                            </button>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </> : (tab === 'tuition' ?
                                        <div className="row" data-aos="fade-up" data-aos-duration="1000">
                                            <div className="col-lg-4">
                                                <div className="student-profile">
                                                    <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                                    <b>{data.firstname + " " + data.lastname}</b>
                                                    <span>{GradeToString(data.grade)}</span>
                                                    <em data-color={data.isInside ? 'blue' : 'red'}>
                                                        {data.isInside ? 'داخل محوطه' : 'عدم حضور'}
                                                    </em>
                                                </div>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="screen-card">
                                                    <div className="screen-card-header">
                                                        <b>وضعیت شهریه</b>
                                                        <div style={{gap: 10}} className={"d-inline-flex"}>
                                                            {
                                                                data.tuitionPercentPaid < 100 ?
                                                                    <button onClick={() => setPayModal({
                                                                        show: true,
                                                                        price: 0,
                                                                    })}>
                                                                        <ThinCardIcon/>
                                                                        <span>پرداخت</span>
                                                                    </button> : null
                                                            }
                                                            {
                                                                data.tuition.length > 0 ?
                                                                    <button
                                                                        onClick={() => window.open(`/print/admins/student-tuition/${studentId}`)}>
                                                                        <ThinPrintIcon/>
                                                                        <span>پرینت</span>
                                                                    </button> : null
                                                            }
                                                            <button onClick={() => setSignModal(true)}>
                                                                <ThinTaskIcon/>
                                                                <span>تنظیم قرارداد</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row justify-content-center">
                                                        <div className="col-lg-4">
                                                            <div className="tuition-status">
                                                                <span>وضعیت</span>
                                                                <b>{!data.isTuitionSet ? 'نامشخص' : (data.tuitionPercentPaid === 100 || data.tuitionTotalPrice === 0 ? 'تکمیل شده' : 'بدهکار')}</b>
                                                                <strong>{CurrencyFormat(data.tuitionPercentPaid.toFixed(0))}٪
                                                                    پرداخت
                                                                    شده</strong>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                                        style={{width: `${data.tuitionPercentPaid}%`}}/>
                                                                </div>
                                                                {data.extraProgramCost > 0 ? <em>دارای فوق برنامه
                                                                    ({CurrencyFormat(data.extraProgramCost)} تومان)</em> : null}
                                                                {data.offAmount > 0 ?
                                                                    <em> {CurrencyFormat(data.offAmount)} تومان تخفیف اعمال
                                                                        شده است.</em> : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="tuition-status">
                                                                <span>پرداخت شده</span>
                                                                <p style={{color: 'darkgreen'}}>{CurrencyFormat(data.tuitionPaidSoFar)}
                                                                    <TomansIcon/></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="tuition-status">
                                                                <span>بدهکاری</span>
                                                                <p style={{color: '#8b0000'}}>{CurrencyFormat(data.tuitionTotalPrice - data.tuitionPaidSoFar)}
                                                                    <TomansIcon/></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className="screen-card-header">
                                                        <b>لیست پرداخت‌های شهریه</b>
                                                        <button onClick={() => setAddEditPayment({
                                                            price: 0,
                                                            paidDate: '2000-01-01 00:00:00',
                                                            payMethod: 'cash',
                                                            edit: false,
                                                            id: 0,
                                                            show: true,
                                                        })}>
                                                            <ThinAddIcon/>
                                                            <span>پرداخت جدید</span>
                                                        </button>
                                                    </div>

                                                    {
                                                        data.tuition.length > 0 ?
                                                            <>
                                                                <table
                                                                    className="table open-table table-hover table-bordered">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>مبلغ</th>
                                                                        <th>وضعیت</th>
                                                                        <th>تاریخ پرداخت</th>
                                                                        <th>نوع پرداخت</th>
                                                                        <th>امکانات</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        data.tuition.map((t, i) =>
                                                                            <tr key={"U23j82nD" + i}>
                                                                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                                <td>
                                                                                    <span>{CurrencyFormat(t.price)}<TomansIcon/></span>
                                                                                </td>
                                                                                <td><em><CheckIcon/>پرداخت شده</em></td>
                                                                                <td>{StringDigitsConvertToPersian(GregorianToPersian(t.paidAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                                                                <td>{t.payMethod === 'old' ? 'سامانه قدیم' : (t.payMethod === 'cash' ? 'فیش' : 'آنلاین')}</td>
                                                                                <td>
                                                                                    <div style={{gap: 5}}
                                                                                         className="d-inline-flex align-items-center">
                                                                                        {
                                                                                            t.payMethod !== 'online' ?
                                                                                                <>
                                                                                                    <button
                                                                                                        onClick={() => setAddEditPayment({
                                                                                                            id: t.id,
                                                                                                            show: true,
                                                                                                            edit: true,
                                                                                                            payMethod: t.payMethod,
                                                                                                            paidDate: t.paidAt,
                                                                                                            price: t.price,
                                                                                                        })}
                                                                                                        className="open-tooltip">
                                                                                                        <ThinEditIcon/>
                                                                                                        <i>ویرایش</i>
                                                                                                    </button>
                                                                                                    <button
                                                                                                        onClick={() => setRemovePayment({
                                                                                                            show: true,
                                                                                                            id: t.id,
                                                                                                        })}
                                                                                                        className="open-tooltip">
                                                                                                        <ThinTrashIcon/>
                                                                                                        <i>حذف</i>
                                                                                                    </button>
                                                                                                </> :
                                                                                                <button
                                                                                                    onClick={() => setPaymentInfoModal({
                                                                                                        show: true,
                                                                                                        id: t.id,
                                                                                                    })}
                                                                                                    className="open-tooltip">
                                                                                                    <ThinInfoIcon/>
                                                                                                    <i>اطلاعات</i>
                                                                                                </button>
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                    </tbody>
                                                                </table>
                                                            </> : <div className="staff--not-found">
                                                                <b>پرداختی یافت نشد</b>
                                                                <p>هنوز پرداختی برای شهریه صورت نگرفته است.</p>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                can.reminders ?
                                                    <div className="col-lg-12">
                                                        <div className="screen-card">
                                                            <div className="screen-card-header">
                                                                <b>یادآوری‌های شهریه</b>
                                                                <button onClick={() => setAddEditReminder({
                                                                    show: true,
                                                                    id: 0,
                                                                    edit: false,
                                                                    isReminded: false,
                                                                    date: '2000-01-01',
                                                                    price: 0,
                                                                })}>
                                                                    <ThinAddIcon/>
                                                                    <span>افزودن</span>
                                                                </button>
                                                            </div>
                                                            <table
                                                                className="table open-table table-bordered table-hover">
                                                                <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>تاریخ</th>
                                                                    <th>مبلغ</th>
                                                                    <th>وضعیت</th>
                                                                    <th>امکانات</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                    remindersList.map((r, i) =>
                                                                        <tr key={"k39Dj28D" + i}>
                                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(r.date).replaceAll("-", "/"))}</td>
                                                                            <td>
                                                                                <span>{CurrencyFormat(r.price)}<TomansIcon/></span>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    r.isReminded === 1 ?
                                                                                        <em>
                                                                                            <CheckIcon/>
                                                                                            اعلام شده
                                                                                        </em> :
                                                                                        <em data-color={"red"}>
                                                                                            <ThinTimeIcon/>
                                                                                            در انتظار
                                                                                        </em>
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                <div style={{gap: 5}}
                                                                                     className="d-inline-flex align-items-center">
                                                                                    <button className="open-tooltip"
                                                                                            onClick={() => setPayModal({
                                                                                                show: true,
                                                                                                price: r.price,
                                                                                            })}>
                                                                                        <ThinCreditScoreIcon/>
                                                                                        <i>پرداخت</i>
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => setAddEditReminder({
                                                                                            show: true,
                                                                                            id: r.id,
                                                                                            edit: true,
                                                                                            price: r.price,
                                                                                            date: r.date,
                                                                                            isReminded: r.isReminded === 1,
                                                                                        })}
                                                                                        className="open-tooltip">
                                                                                        <ThinEditIcon/>
                                                                                        <i>ویرایش</i>
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => setRemoveReminder({
                                                                                            id: r.id,
                                                                                            show: true,
                                                                                        })}
                                                                                        className="open-tooltip">
                                                                                        <ThinTrashIcon/>
                                                                                        <i>حذف</i>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div> : null
                                            }
                                        </div> :
                                        (tab === 'store' ?
                                            <div className="row" data-aos="fade-up" data-aos-duration="1000">
                                                <div className="col-lg-4">
                                                    <div className="student-profile">
                                                        <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                                        <b>{data.firstname + " " + data.lastname}</b>
                                                        <span>{GradeToString(data.grade)}</span>
                                                        <em data-color={data.isInside ? 'blue' : 'red'}>
                                                            {data.isInside ? 'داخل محوطه' : 'عدم حضور'}
                                                        </em>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8">
                                                    <div className="screen-card">
                                                        <div className="screen-card-header">
                                                            <b>حساب بوفه</b>
                                                        </div>
                                                        <div className="person-account-balance">
                                                            <div className="person-account-balance-main">
                                                                <span>{CurrencyFormat(data.balance)}</span>
                                                                <TomansIcon/>
                                                            </div>
                                                            <div className="d-block"/>
                                                            <button className="person-account-balance-increase"
                                                                    onClick={() => setIncreaseBalanceModal(true)}>
                                                                <i><ThickAddIcon/></i>
                                                                <span>افزایش اعتبار</span>
                                                            </button>
                                                            <div className="person-account-balance-max">
                                                    <span className="f-roboto">
                                                        حداکثر میزان خرید روزانه:
                                                        {" " + CurrencyFormat(data.maxBuyPerDay) + " "}
                                                        تومان
                                                    </span>
                                                                <button onClick={() => setEditMaxModal(true)}>
                                                                    ویرایش
                                                                </button>
                                                            </div>
                                                            <div className="person-account-balance-hint f-roboto">
                                                                هنگام ثبت اطلاعات در دستگاه آرتیسان، مبلغ وارد شده از حساب
                                                                این شخص
                                                                کسر خواهد شد و درصورت کمبود موجودی از اعمال تراکنش جلوگیری
                                                                می‌گردد.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="screen-card">
                                                        <div className="screen-card-header">
                                                            <b>گزارشات بوفه</b>
                                                            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                                                                <div className="filter-buttons">
                                                                    <ClickOutsideDetector
                                                                        onClickOutside={() => {
                                                                            setStoreFilters(v => {
                                                                                let x = {...v};
                                                                                x.shown = '';
                                                                                return x;
                                                                            });
                                                                        }}
                                                                        className={"filter-button-c" + (storeFilters.shown === 'time' ? ' active' : '')}>
                                                                        <button onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setStoreFilters(v => {
                                                                                let x = {...v};
                                                                                x.shown = x.shown === 'time' ? '' : 'time';
                                                                                return x;
                                                                            });
                                                                        }}>
                                                                            <ThinTimeIcon/>
                                                                            <span>محدودیت زمانی</span>
                                                                            <ThinCaretDownIcon/>
                                                                        </button>
                                                                        {
                                                                            storeFilters.shown === 'time' ?
                                                                                <div>
                                                                                    <label className="f-roboto">لطفا یک بازه
                                                                                        زمانی را انتخاب
                                                                                        کنید:</label>
                                                                                    <Calendar
                                                                                        value={timeForStore}
                                                                                        onChange={e => setTimeForStore(e)}
                                                                                        shouldHighlightWeekends
                                                                                        colorPrimary='#0a53be'
                                                                                        locale={'fa'}
                                                                                    />
                                                                                    <div className="text-end">
                                                                                        <button
                                                                                            className="filter-button-cta"
                                                                                            onClick={fetchStoreList}>
                                                                                            <span>اعمال تغییرات</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div> :
                                                                                null
                                                                        }
                                                                    </ClickOutsideDetector>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            storeList.length === 0 ?
                                                                <div className="staff--not-found">
                                                                    <b>گزارشی یافت نشد</b>
                                                                    <p>در بازه زمانی انتخاب شده، گزارشی یافت نشد.</p>
                                                                </div> :
                                                                null
                                                        }
                                                        {
                                                            storeList.length > 0 ?
                                                                <table
                                                                    className="table open-table table-bordered table-hover">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>نوع</th>
                                                                        <th>مبلغ</th>
                                                                        <th>پرداخت</th>
                                                                        <th>تاریخ</th>
                                                                        <th>زمان</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        storeList.map((r, i) =>
                                                                                <tr key={"Jd932uf8" + i}>
                                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                                    <td>{pointTransactionSourceToString(r.source)}</td>
                                                                                    <td>
                                                                <span
                                                                    style={{color: r.price < 0 ? '#8b0000' : 'darkgreen'}}>
                                                                    {CurrencyFormat(r.price.toString().replace('-', '')) + (r.price < 0 ? '-' : '+')}
                                                                    <TomansIcon/>
                                                                </span>
                                                                                    </td>
                                                                                    <td>{pointTransactionPayMethodToString(r.method)}</td>
                                                                                    <td>{StringDigitsConvertToPersian(GregorianToPersian(r.createdAt).replaceAll('-', '/'))}</td>
                                                                                    <td>{StringDigitsConvertToPersian(r.createdAt.split(' ')[1])}</td>
                                                                                </tr>
                                                                        )
                                                                    }
                                                                    </tbody>
                                                                </table> : null
                                                        }
                                                    </div>
                                                </div>
                                            </div> : (
                                                tab === 'attend' ?
                                                    <div className="row" data-aos="fade-up" data-aos-duration="1000">
                                                        <div className="col-lg-4">
                                                            <div className="student-profile">
                                                                <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                                                <b>{data.firstname + " " + data.lastname}</b>
                                                                <span>{GradeToString(data.grade)}</span>
                                                                <em data-color={data.isInside ? 'blue' : 'red'}>
                                                                    {data.isInside ? 'داخل محوطه' : 'عدم حضور'}
                                                                </em>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-8">
                                                            <div className="screen-card">
                                                                <div className="screen-card-header">
                                                                    <b>ارسال پیامک به سرپرست</b>
                                                                </div>
                                                                <button
                                                                    className={"techaran-switch" + (data.smsIfAbsent ? ' active' : '')}
                                                                    onClick={() => setData(v => {
                                                                        let x = {...v};
                                                                        x.smsIfAbsent = !x.smsIfAbsent;
                                                                        ChangeSMSConditions(x.smsIfAbsent ? 1 : 0, -1, -1);
                                                                        return x;
                                                                    })}>
                                                                    <i><b/></i>
                                                                    <span>
                                            وجود در لیست غایبین
                                            <em>اگر دانش‌آموز در لیست غایبین باشد، پیامک ارسال می‌گردد.</em>
                                        </span>
                                                                </button>
                                                                <button
                                                                    className={"techaran-switch" + (data.smsIfEnter ? ' active' : '')}
                                                                    onClick={() => setData(v => {
                                                                        let x = {...v};
                                                                        x.smsIfEnter = !x.smsIfEnter;
                                                                        ChangeSMSConditions(-1, x.smsIfEnter ? 1 : 0, -1);
                                                                        return x;
                                                                    })}>
                                                                    <i><b/></i>
                                                                    <span>
                                            ورود
                                            <em>زمانیکه دانش‌آموز ورود خود را ثبت کند پیامک ارسال می‌شود.</em>
                                        </span>
                                                                </button>
                                                                <button
                                                                    className={"techaran-switch" + (data.smsIfExit ? ' active' : '')}
                                                                    onClick={() => setData(v => {
                                                                        let x = {...v};
                                                                        x.smsIfExit = !x.smsIfExit;
                                                                        ChangeSMSConditions(-1, -1, x.smsIfExit ? 1 : 0);
                                                                        return x;
                                                                    })}>
                                                                    <i><b/></i>
                                                                    <span>
                                            خروج
                                            <em>زمانیکه دانش‌آموز خروج خود را ثبت کند پیامک ارسال می‌شود.</em>
                                        </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="screen-card">
                                                                <div className="screen-card-header">
                                                                    <b>اطلاعات حضورغیاب</b>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 10
                                                                    }}>
                                                                        {/*{*/}
                                                                        {/*    attendList.length > 1 ?*/}
                                                                        {/*        <button onClick={() => {*/}
                                                                        {/*            window.open(`/admins/attend/print/${time.from!.year}-${time.from!.month}-${time.from!.day}/${time.to!.year}-${time.to!.month}-${time.to!.day}/${studentId}`);*/}
                                                                        {/*        }}>*/}
                                                                        {/*            <ThinPrintIcon/>*/}
                                                                        {/*            <span>پرینت</span>*/}
                                                                        {/*        </button> : null*/}
                                                                        {/*}*/}
                                                                        <div className="filter-buttons">
                                                                            <ClickOutsideDetector
                                                                                onClickOutside={() => {
                                                                                    setFilters(v => {
                                                                                        let x = {...v};
                                                                                        x.shown = '';
                                                                                        return x;
                                                                                    });
                                                                                }}
                                                                                className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                                                                <button onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setFilters(v => {
                                                                                        let x = {...v};
                                                                                        x.shown = x.shown === 'time' ? '' : 'time';
                                                                                        return x;
                                                                                    });
                                                                                }}>
                                                                                    <ThinTimeIcon/>
                                                                                    <span>محدودیت زمانی</span>
                                                                                    <ThinCaretDownIcon/>
                                                                                </button>
                                                                                {
                                                                                    filters.shown === 'time' ?
                                                                                        <div>
                                                                                            <label className="f-roboto">لطفا
                                                                                                یک بازه زمانی را انتخاب
                                                                                                کنید:</label>
                                                                                            <Calendar
                                                                                                value={time}
                                                                                                onChange={e => setTime(e)}
                                                                                                shouldHighlightWeekends
                                                                                                colorPrimary='#0a53be'
                                                                                                locale={'fa'}
                                                                                            />
                                                                                            <div className="text-end">
                                                                                                <button
                                                                                                    className="filter-button-cta"
                                                                                                    onClick={fetchList}>
                                                                                                    <span>اعمال تغییرات</span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div> :
                                                                                        null
                                                                                }
                                                                            </ClickOutsideDetector>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    attendList.length === 0 ?
                                                                        <div className="staff--not-found">
                                                                            <b>گزارشی یافت نشد</b>
                                                                            <p>در بازه زمانی انتخاب شده، گزارشی یافت
                                                                                نشد.</p>
                                                                        </div> :
                                                                        null
                                                                }
                                                                {
                                                                    attendList.length > 0 ?
                                                                        <table
                                                                            className="table open-table table-bordered table-hover">
                                                                            <thead>
                                                                            <tr>
                                                                                <th>#</th>
                                                                                <th>نوع</th>
                                                                                <th>تاریخ</th>
                                                                                <th>زمان</th>
                                                                                <th>ثبت‌کننده</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {
                                                                                attendList.map((r, i) =>
                                                                                    <tr key={"Jd932uf8" + i}>
                                                                                        <td>{StringDigitsConvertToPersian((i + 1).toString())}</td>
                                                                                        <td>{r.isEntrance ? 'ورود' : 'خروج'}</td>
                                                                                        <td>{StringDigitsConvertToPersian(GregorianToPersian(r.createdAt).replaceAll('-', '/'))}</td>
                                                                                        <td>{StringDigitsConvertToPersian(r.createdAt.split(' ')[1])}</td>
                                                                                        <td>{r.isAuto === 0 ? 'دستگاه' : 'خروج خودکار'}</td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                            </tbody>
                                                                        </table> : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div> : null
                                            ))
                                )
                        }
                    </div> : null
            }
            <AddEditStudentModal
                active={editModal}
                closeHandler={() => setEditModal(false)}
                studentId={parseInt(studentId as string)}
                isEdit={true}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
            <AddBalanceModal
                active={increaseBalanceModal}
                closeHandler={() => setIncreaseBalanceModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                    fetchStoreList();
                }}
                currentBalance={data.balance}
                studentId={studentId as string}
                customerName={data.firstname + " " + data.lastname}
            />
            <StudentMaxPayPerDayEditModal
                active={editMaxModal}
                closeHandler={() => setEditMaxModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                currentMax={data.maxBuyPerDay}
                employeeId={studentId as string}
            />
            <RemoveModal
                active={removePayment.show}
                closeHandler={() => setRemovePayment(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف پرداخت"}
                desc={"آیا مطمئن هستید می‌خواهید این پرداخت حذف گردد؟"}
                onRemove={doRemovePayment}
            />
            <RemoveModal
                active={removeReminder.show}
                closeHandler={() => setRemoveReminder(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف یادآوری"}
                desc={"آیا مطمئن هستید می‌خواهید این یادآوری حذف گردد؟"}
                onRemove={doRemoveReminder}
            />
            <AddEditTuitionPaymentModal
                active={addEditPayment.show}
                closeHandler={() => setAddEditPayment((e) => {
                    let x = {...e};
                    x.show = false;
                    return x;
                })}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                id={addEditPayment.id}
                isEdit={addEditPayment.edit}
                price={addEditPayment.price}
                paidDate={addEditPayment.paidDate}
                payMethod={addEditPayment.payMethod}
                studentId={studentId as string}
                totalLeft={data.tuitionTotalPrice - data.tuitionPaidSoFar}
            />
            <AddEditTuitionReminderModal
                active={addEditReminder.show}
                remindDate={addEditReminder.date}
                price={addEditReminder.price}
                isReminded={addEditReminder.isReminded}
                isEdit={addEditReminder.edit}
                reminderId={addEditReminder.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                closeHandler={() => setAddEditReminder(b => {
                    let x = {...b};
                    x.show = false;
                    return x;
                })}
                studentId={studentId as string}
            />
            <SignTuitionModal
                active={signModal}
                closeHandler={() => setSignModal(false)}
                isSigned={data.isTuitionSet}
                default={data.defaultTuitionPrice}
                current={data.tuitionTotalPrice}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                studentId={studentId as string}
                defaultExtraProgramCost={data.defaultExtraProgramCost}
                extraProgramCost={data.extraProgramCost}
                offAmount={data.offAmount}
            />
            <AdminTuitionPaymentInfoModal
                active={paymentInfoModal.show}
                closeHandler={() => setPaymentInfoModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                paymentId={paymentInfoModal.id}
            />
            <AdminPayTuitionModal
                active={payModal.show}
                closeHandler={() => setPayModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                studentId={studentId as string}
                price={payModal.price}
                min={1}
                paidSoFar={data.tuitionPaidSoFar}
                totalPrice={data.tuitionTotalPrice}
            />
            <RemoveModal
                active={removeCard}
                closeHandler={() => setRemoveCard(false)}
                title={"حذف کارت"}
                desc={"آیا مطمئن هستید می‌خواهید این کارت را برای دانش آموز حذف کنید؟"}
                onRemove={() => {
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/students/assign-card',
                        {
                            id: studentId,
                            rfid: '',
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'کارت حذف شد.',
                                'باشه',
                                5000,
                            );
                            setData(v => {
                                let x = {...v};
                                x.cardCode = '';
                                return x;
                            });
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void (0));
                }}
            />
            <AdminsAssignCardToStudentModal
                active={assignCard}
                closeHandler={() => setAssignCard(false)}
                studentId={studentId as string}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
            <AdminsEditWhoGetsSMSModal
                active={whoGetsSMS}
                closeHandler={() => setWhoGetsSMS(false)}
                whoGets={data.whoGetsSMS}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                studentId={studentId as string}
                motherTell={data.motherTell}
                fatherTell={data.fatherTell}
            />
            <AdminsEditWhoGetsConsentsSMSModal
                active={whoGetsConsents}
                closeHandler={() => setWhoGetsConsents(false)}
                whoGets={data.consentSMS}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                studentId={studentId as string}
                motherTell={data.motherTell}
                fatherTell={data.fatherTell}
            />
        </>
    );
};

export const pointTransactionSourceToString = (source: 'device' | 'operator' | 'online' | 'station') => {
    switch (source) {
        case "device":
            return "خرید";
        case "online":
            return "شارژ آنلاین";
        case "operator":
            return "توسط اپراتور";
        case "station":
            return "لوازم‌التحریر";
        default:
            return "نامشخص";
    }
};
export const pointTransactionPayMethodToString = (method: 'online' | 'cash' | 'credit') => {
    switch (method) {
        case "online":
            return "پرداخت آنلاین";
        case "cash":
            return "پول نقدی";
        case "credit":
            return "برداشت از موجودی";
        default:
            return "نامشخص";
    }
};